/**
 * Used by `service-invoice` and other support-billing call sites.
 * redo/model/src/support/billing/ai-billing.ts re-exports for back-compat.
 */
export enum SupportAiBillingVersion {
  /** Bucketed usage - progressive pricing based on volume tiers */
  BUCKETED_USAGE = "bucketed_usage",
  /** Simple AI usage - flat per-resolution rate without volume discounts */
  SIMPLE_AI_USAGE = "simple_ai_usage",
  /** Per-order billing - charges per order using the same logic as checkout optimization */
  PER_ORDER = "per_order",
}
